import React, { memo } from 'react';

const SEVERITY_STYLES = {
  normal: 'shm-severity-normal',
  elevated: 'shm-severity-elevated',
  significant: 'shm-severity-significant',
  critical: 'shm-severity-critical',
};

const SeverityBadge = memo(function SeverityBadge({ severity }) {
  const label = severity || 'normal';
  return (
    <span className={`shm-severity-badge ${SEVERITY_STYLES[label] || SEVERITY_STYLES.normal}`}>
      {label}
    </span>
  );
});

export default SeverityBadge;
